'use client';

import { chakra, SystemStyleObject } from '@chakra-ui/react';

const TRAILING_PSEUDO_REGEX = /(::?[\w-]+(?:\([^)]*\))?)+$/;
const EXCLUDE_CLASSNAME = '.not-prose';

function inWhere(selector: string) {
    const rebuiltSelector = selector.startsWith('& ') ? selector.slice(2) : selector;
    const match = selector.match(TRAILING_PSEUDO_REGEX);
    const pseudo = match ? match[0] : '';
    const base = match ? selector.slice(0, -match[0].length) : rebuiltSelector;
    return `& :where(${base}):not(${EXCLUDE_CLASSNAME}, ${EXCLUDE_CLASSNAME} *)${pseudo}`;
}

// Basic styling setup, may be extended for future AI/Markdown-driven sections
export const Prose = chakra('div', {
    base: {
        /* paragraphs */
        [inWhere('& p')]: {
            marginTop: '1em',
            marginBottom: '1em',
        },

        /* headings */
        [inWhere('& h1, & h2, & h3, & h4')]: {
            fontWeight: '600',
            marginTop: '1.5em',
            marginBottom: '0.5em',
        },

        [inWhere('& h2:first-child')]: {
            marginTop: '0.25em',
        },

        /* lists */
        [inWhere('& ul, & ol')]: {
            marginTop: '.5em',
            marginBottom: '1em',
            paddingInlineStart: '1em',
        },

        [inWhere('& li')]: {
            marginTop: '0.25em',
            marginBottom: '0.25em',
        },

        /* emphasis */
        [inWhere('& strong')]: {
            fontWeight: '600',
        },

        [inWhere('& em')]: {
            fontStyle: 'italic',
        },

        /* links */
        [inWhere('& a')]: {
            textDecoration: 'underline',
            color: 'var(--chakra-colors-secondary-600)',
        },
    } as SystemStyleObject,
});
